import * as echarts from 'echarts';
import { nextTick } from 'vue';
export default {
  name: "testPieChart",
  props: {
    data: {
      type: Object,
      default: () => {
        return {
          notDoNum: 0,
          rightAnswer: 0,
          wrongAnswer: 0
        };
      }
    }
  },
  watch: {
    data() {
      this.render();
    }
  },
  methods: {
    render() {
      let option = {
        title: {
          text: '答题结果',
          subtext: '给出正确、错误、未答分布'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          bottom: 'bottom',
          left: 'center'
        },
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        },
        series: [{
          type: 'pie',
          radius: ['40%', '70%'],
          itemStyle: {
            borderRadius: 10,
            borderColor: '#fff',
            borderWidth: 2
          },
          data: [{
            value: this.data.rightAnswer,
            name: '正确',
            itemStyle: {
              color: '#77DD77'
            }
          }, {
            value: this.data.wrongAnswer,
            name: '错误',
            itemStyle: {
              color: '#FF5733'
            }
          }, {
            value: this.data.notDoNum,
            name: '未答',
            itemStyle: {
              color: '#FFD700'
            }
          }],
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          label: {
            show: true,
            // 显示标签
            position: 'inside',
            formatter: '{b}数量：{c}，占比：{d}%',
            textStyle: {
              color: 'black'
            }
          },
          labelLine: {
            show: false // 设置为 false 关闭指示线
          }
        }]
      };
      let pie = document.getElementById('pieChart');
      let exist = echarts.getInstanceByDom(pie);
      if (exist) {
        console.log(this.id, '销毁已存在的');
        exist.dispose();
      }
      let chart = echarts.init(pie);
      chart.setOption(option);
    },
    init() {
      this.$nextTick(() => this.render());
    }
  },
  mounted() {
    this.init();
  }
};